import React from 'react';
import DestinationTemplate from '../../components/DestinationTemplate';

const HimachalPage = () => {
  return <DestinationTemplate destinationId="himachal" />;
};

export default HimachalPage;
